// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3NtNX","question":"Question_question__351Kk","description":"Question_description__3B0aa"};